import { apiRequest, apiRequestRaw } from './apiClient';

export interface ProcessingJobRequest {
  workflowId: string;
  metadata?: Record<string, string>;
  definedInputs?: Record<string, unknown>;
  settings?: Record<string, unknown>;
  inputFileConfigurations?: Record<string, unknown>;
}

export type JobStatus = 'InProgress' | 'Succeeded' | 'Failed' | 'Skipped';

export interface StepDescriptor {
  stepId: string | null;
  iterationKey: string | null;
  isSkipped: boolean;
}

export interface RuntimeInfo {
  completedSteps: StepDescriptor[] | null;
}

export interface JobError {
  errorMessage?: string;
  message?: string; // fallback alias
  code?: string;
  target?: string; // stepId of the failed step
  details?: unknown[];
}

export interface ProcessingJob {
  processingJobId: string;
  workflowId: string;
  status: JobStatus;
  createdAt: string;
  finishedAt: string | null;
  updatedAt: string | null;
  error?: JobError | null;
  output?: Record<string, unknown> | null;
  runtimeInfo?: RuntimeInfo | null;
}

export const createProcessingJob = async (
  request: ProcessingJobRequest,
  file?: File,
): Promise<ProcessingJob> => {
  const formData = new FormData();
  formData.append('request', JSON.stringify(request));
  if (file) {
    formData.append('File', file, file.name);
  }

  // FormData body — use apiRequestRaw so the browser sets the proper
  // multipart Content-Type with boundary. Auth header + error normalisation
  // stay identical to the JSON path.
  return apiRequestRaw<ProcessingJob>('/processingJobs', {
    method: 'POST',
    body: formData,
  });
};

export const getProcessingJob = async (
  processingJobId: string,
  includeRuntimeInfo = false,
): Promise<ProcessingJob> =>
  apiRequest<ProcessingJob>(
    `/processingJobs/${encodeURIComponent(processingJobId)}?includeRuntimeInfo=${includeRuntimeInfo}`,
  );
